import { render, staticRenderFns } from "./LocalServerConfig.vue?vue&type=template&id=1c90f6ed&"
import script from "./LocalServerConfig.vue?vue&type=script&lang=js&"
export * from "./LocalServerConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports